/**
 * SeoText — homepage editorial / SEO content (TSS-535)
 *
 * Single source of truth for the SEO copy + internal links. Kept as DATA so the
 * component stays a thin renderer (no wall of inline <TextLink> markup).
 *
 * A paragraph is an array of segments: a plain string renders as text, an
 * object renders as a contextual <TextLink>. Links point to REAL store-1
 * (code "default") category request_paths, kept RELATIVE on purpose — verified
 * HTTP 200. These anchors are the block's biggest SEO win.
 *
 * "polizoare unghiulare" stays plain text: no active main category on store 1
 * (only a spare-parts category exists).
 */
export type SeoSegment = string | { text: string; href: string }

export interface SeoSection {
  heading: string
  paragraphs: SeoSegment[][]
}

export const SEO_SECTIONS: SeoSection[] = [
  {
    heading: 'Magazin online de scule, unelte și echipamente profesionale',
    paragraphs: [
      [
        'La Tools Store găsești o gamă variată de ',
        { text: 'scule electrice', href: '/scule/electrice.html' },
        ', ',
        { text: 'unelte de mână', href: '/scule/manuale.html' },
        ', echipamente pentru construcții, ',
        {
          text: 'utilaje pentru grădină',
          href: '/unelte-utilaje-gradina-agricole.html',
        },
        ' și accesorii destinate atât profesioniștilor, cât și pasionaților de bricolaj. Punem la dispoziție produse atent selecționate pentru lucrări de construcții, renovări, întreținere, instalații, prelucrarea lemnului și amenajarea spațiilor exterioare.',
      ],
      [
        'În oferta noastră vei descoperi categorii esențiale precum bormașini și mașini de găurit, ',
        {
          text: 'ciocane rotopercutoare',
          href: '/scule/electrice/ciocane-rotopercutoare.html',
        },
        ', polizoare unghiulare, ',
        { text: 'aparate de sudură', href: '/sudura.html' },
        ', ',
        {
          text: 'pompe submersibile',
          href: '/unelte-utilaje-gradina-agricole/instalatii-irigatii/pompe-submersibile.html',
        },
        ', ',
        {
          text: 'hidrofoare',
          href: '/unelte-utilaje-gradina-agricole/instalatii-irigatii/pompe-suprafata-hidrofoare.html',
        },
        ', ',
        {
          text: 'motocoase',
          href: '/unelte-utilaje-gradina-agricole/gazon/motocoase-motor-termic.html',
        },
        ', ',
        { text: 'drujbe', href: '/unelte-utilaje-gradina-agricole/drujbe.html' },
        ', scule de grădină și numeroase accesorii pentru utilizare profesională sau casnică. Navigarea rapidă între categorii te ajută să găsești exact unealta potrivită pentru orice proiect.',
      ],
      [
        'Colaborăm cu producători și branduri recunoscute în industrie, oferind soluții fiabile pentru șantiere, ateliere, agricultură și gospodărie. Indiferent dacă ai nevoie de scule electrice performante, echipamente pentru întreținerea grădinii sau produse pentru alimentarea și gestionarea apei, vei găsi opțiuni adaptate diferitelor bugete și niveluri de utilizare.',
      ],
      [
        'Alegând Tools Store beneficiezi de produse cu garanție, suport specializat înainte și după achiziție, livrare rapidă și posibilitatea de retur conform politicilor magazinului. Experiența acumulată în domeniul sculelor și echipamentelor profesionale ne permite să oferim soluții eficiente atât pentru utilizatorii profesioniști, cât și pentru cei care realizează proiecte în regim propriu.',
      ],
    ],
  },
  {
    heading: 'Soluții pentru profesioniști și pasionați de bricolaj',
    paragraphs: [
      [
        'Tools Store se adresează unei game variate de utilizatori, de la profesioniști din domeniul construcțiilor și instalațiilor până la pasionații care își realizează singuri proiectele din gospodărie. ',
        { text: 'Constructorii', href: '/scule/constructii.html' },
        ' pot găsi scule electrice, echipamente de șantier și unelte robuste pentru lucrări de zidărie, finisaje și renovări, în timp ce ',
        { text: 'instalatorii', href: '/scule/instalatii.html' },
        ' beneficiază de soluții dedicate pentru montaj, întreținere și reparații.',
      ],
      [
        'Pentru electricieni, oferta include aparate de măsură, unelte specializate și accesorii necesare intervențiilor rapide și sigure. ',
        {
          text: 'Tâmplarii',
          href: '/scule/utilaje-ateliere-tamplarie.html',
        },
        ' și profesioniștii din prelucrarea lemnului au la dispoziție fierăstraie, mașini de găurit, polizoare și alte echipamente care contribuie la obținerea unor rezultate precise și eficiente.',
      ],
      [
        'Agricultorii și utilizatorii care întrețin grădini, livezi sau terenuri agricole pot alege dintr-o selecție variată de motocoase, drujbe, pompe, hidrofoare și alte utilaje concepute pentru activități desfășurate în exterior. În același timp, pasionații de bricolaj găsesc unelte și echipamente potrivite pentru proiecte de amenajare, întreținere și reparații realizate acasă.',
      ],
      [
        'Indiferent de domeniul de activitate sau de complexitatea proiectului, alegerea unor scule și unelte de calitate contribuie la creșterea productivității, la obținerea unor rezultate mai bune și la desfășurarea lucrărilor în condiții de siguranță.',
      ],
    ],
  },
]
